enum WidgetPlatform {
    godaddy = 'godaddy',
    squarespace = 'squarespace',
    webflow = 'webflow',
    weebly = 'weebly',
    wix = 'wix',
    wordpress = 'wordpress',
    other = 'other',
}

const WIDGET_LIBRARY_CODE_PLACEHOLDER = 'WIDGET_LIBRARY_CODE_PLACEHOLDER';
const WIDGET_DISPLAY_CODE_PLACEHOLDER = 'WIDGET_DISPLAY_CODE_PLACEHOLDER';
const WIDGET_ACCOUNT_ID_PLACEHOLDER = 'WIDGET_ACCOUNT_ID_PLACEHOLDER';

export {
    WidgetPlatform,
    WIDGET_LIBRARY_CODE_PLACEHOLDER,
    WIDGET_DISPLAY_CODE_PLACEHOLDER,
    WIDGET_ACCOUNT_ID_PLACEHOLDER,
};
